import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

export default function GraficoSumOfLitros({ dados }) {
  console.log('Dados em GraficoSumOfLitros: ', dados);
  const capacidadeTotal = dados[0].capacidade;
  const valorUtilizado = dados[0].dialisado;
  const restante = capacidadeTotal - valorUtilizado;

  console.log('Valores: ', capacidadeTotal, valorUtilizado, restante);

  const data = {

    labels: ['Dialisado', 'Disponível'],
    datasets: [
      {
        label: "Sum Of Litros",
        data: [valorUtilizado, restante],
        backgroundColor: ['#4CAF50', '#e0e0e0'],
        borderWidth: 0,
      },
    ],
  };

  const options = {

    rotation: -90,        // começa no topo
    circumference: 180,   // semi-círculo
    cutout: '70%',        // espessura do arco
    plugins: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false,
        position: 'bottom',
      },
      title: {
        display: true,
        text: 'Soma de Litros',
        font: { size: 16 },
        padding: { bottom: 20 }
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <div>
    <div className="w-full flex flex-col items-center">
      <Doughnut data={data} options={options} />
    </div>
      <div className="mt-2 text-center">
        <p className="text-lg font-bold">
          {valorUtilizado} / {capacidadeTotal}
        </p>
        <p className="text-sm text-gray-600">Capacidade Utilizada</p>
    </div>
    </div>

  );
}
